
const typeusersCreate = [
    ['vcorp', 'VC (corp)'],
    ['cpt.i', 'Corporate investor'],
    ['b.a', 'Business Angel'],
    ['p.p', 'Public/private'],
    ['ac', 'Accelerator'],
];

export default typeusersCreate;